import {
  CommonRequest,
  CommonResponse,
  DmlResponse,
  Method,
  ServiceName,
} from 'models/common/RestApi';
import { MdSpecManager, MdSpecManagerCondition } from 'models/md/MdEquipmentSpec';
import { callApi } from 'utils/ApiUtil';

/**
 * 기준정보 > 설비사양 조회 (pivot)
 * @param condition
 */
export const findEquipmentSpec = async (condition?: any) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/equipment-spec`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...(condition || {}) }),
  };

  const response: CommonResponse = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : undefined) as any;
};

/**
 * 기준정보 > 설비사양 조회 > 변경이력 목록 조회
 * @param condition
 */
export const findEquipmentSpecHistory = async (condition?: any) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/equipment-spec/hist`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...(condition || {}) }),
  };

  const response: CommonResponse = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : undefined) as any[];
};

/**
 * 기준정보 > 설비사양 저장
 * @param items
 */
export const saveEquipmentSpec = async (items?: any[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/equipment-spec`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: items,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};

/**
 * 기준정보 > 설비사양 담당자 조회
 * @param condition
 */
export const findSpecManager = async (condition?: MdSpecManagerCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/spec-manager`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdSpecManager[];
};

/**
 * 기준정보 > 설비사양 담당자 저장
 */
export const saveSpecManager = async (mdSpecManagers: MdSpecManager[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/md/spec-manager`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: mdSpecManagers,
  };
  const response: CommonResponse<DmlResponse> = await callApi(request);
  return response;
};

/**
 * 나의 담당(플랜트/라인유형/설비군) 목록 조회
 * @param condition
 */
export const findSpecManagerMyItems = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/md/spec-manager/my-items`,
    serviceName: ServiceName.ELM_BE,
  };

  const response: CommonResponse = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as MdSpecManager[];
};
